import { render } from "./lrbYTable.vue?vue&type=template&id=2540e331&scoped=true"
import script from "./lrbYTable.vue?vue&type=script&lang=js"
export * from "./lrbYTable.vue?vue&type=script&lang=js"

import "./lrbYTable.vue?vue&type=style&index=0&id=2540e331&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2540e331"]])

export default __exports__